'use client'

import type { FC } from 'react'
import dayjs from 'dayjs'
import DatePicker from 'components/datetime/DatePicker'
import { Label } from 'ui/label'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const DateField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <DatePicker
                label={field.label as string}
                className='h-11'
                date={value ? new Date(value as string) : undefined}
                setDate={(date: Date | undefined) => {
                    if (date) onChange(field.name, dayjs(date).format('YYYY-MM-DD'), field)
                }}
            />
        </FieldWrapper>
    )
}

export default DateField
